module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-02.690e0268d9d6a590e551b8f7c8d0c511.png";